// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { Button } from '@mantine/core';

import { getActionButtonProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/common';
import type { WorkOrderActionButtonsProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderActionButtons';
import { useWorkOrders } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

export const ReleaseWorkOrderButton = ({ workOrder, onWorkOrderActioned, ...props }: WorkOrderActionButtonsProps) => {
  const { releaseWorkOrder } = useWorkOrders();
  const [saving, setSaving] = useState(false);

  const onRelease = async () => {
    setSaving(true);
    try {
      await releaseWorkOrder(workOrder.workOrderId);
      onWorkOrderActioned();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Button loading={saving} onClick={onRelease} {...getActionButtonProps(props)}>
      Release
    </Button>
  );
};
